import { forwardRef } from "react";
import styled from "styled-components";
import { css } from "@styled-system/css";
import { layout, space, variant } from "styled-system";

import Box from "../Box/Box";

import { CardProps } from "./card.type";
import variants from "./variants";

const StyledCard = styled(Box)<Partial<CardProps>>`
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  ${css({
    width: 100,
    height: 100,
    padding: 6,
    margin: 6,
    backgroundColor: "background-default-color",
    boxShadow: "default",
    borderRadius: 2,
    border: "solid 1px #f1f1f1",
  })}
  ${layout}
  ${space}
  ${(props) => props.css}
  ${variant({ variants })}
`;

const Card = forwardRef(
  (
    { children, htmlTag, analytics, variant = "default", ...props }: CardProps,
    ref
  ) => {
    return (
      <StyledCard
        as={htmlTag}
        ref={ref}
        data-en={analytics?.eventName}
        data-ec={analytics?.eventCategory}
        data-el={analytics?.eventLabel}
        data-ea={analytics?.eventAction}
        data-es={analytics?.eventSection}
        data-et={analytics?.eventType}
        data-ev={analytics?.eventValue}
        variant={variant}
        {...props}
      >
        {children}
      </StyledCard>
    );
  }
);

export default Card;
